import PostsList from './posts-list';

class PostsListPressRelease extends PostsList {
	constructor(el) {
		super(el);

		this.setEndpoint('wp/v2/press_release');
		this.setColumnClasses('small-12');

		if (this.loadMore) {
			this.loadMore.on('load', () => this.loadMediaCoveragePosts());
		}
	}

	loadMediaCoveragePosts() {
		this.loadMorePosts();
	}
}

export default PostsListPressRelease;
